
(function () {
  'use strict';

  /* ── 2. CSILLAGOS HÁTTÉR ────────────────────────────────────
     Rögzített, az egész oldalt lefedő csillagréteg.
     A CSS .ckr-stars-bg + .ckr-star osztályokat használja.
  ──────────────────────────────────────────────────────────── */
  function initStars() {
    // Ne duplikáljuk
    if (document.getElementById('ckrStarsBg')) return;

    var container = document.createElement('div');
    container.id        = 'ckrStarsBg';
    container.className = 'ckr-stars-bg';
    container.setAttribute('aria-hidden', 'true');

    var COUNT       = 90;
    var MIN_SIZE    = 0.5;
    var MAX_SIZE    = 2.2;
    var MIN_OPACITY = 0.08;
    var MAX_OPACITY = 0.5;
    var MIN_DUR     = 3;
    var MAX_DUR     = 7;

    var frag = document.createDocumentFragment();
    for (var i = 0; i < COUNT; i++) {
      var s    = document.createElement('div');
      var size = Math.random() * (MAX_SIZE - MIN_SIZE) + MIN_SIZE;
      var dur  = Math.random() * (MAX_DUR - MIN_DUR) + MIN_DUR;
      var op   = Math.random() * (MAX_OPACITY - MIN_OPACITY) + MIN_OPACITY;

      s.className = 'ckr-star';
      s.style.cssText = [
        'width:'   + size + 'px',
        'height:'  + size + 'px',
        'top:'     + Math.random() * 100 + '%',
        'left:'    + Math.random() * 100 + '%',
        'opacity:' + op,
        '--dur:'   + dur + 's'
      ].join(';');
      frag.appendChild(s);
    }
    container.appendChild(frag);
    document.body.insertBefore(container, document.body.firstChild);
  }

  /* ── 3. SCROLL FADE-UP ANIMÁCIÓ ─────────────────────────────
     Az .ckr-fade-up osztályú elemek belépéskor animálódnak.
     A chakraw-global.css definiálja az animációt.
  ──────────────────────────────────────────────────────────── */
  function initScrollAnimations() {
    // Célpontok: ChakRaw kártyák és szekció elemek
    var selectors = [
      '.ckr-usp-card',
      '.ckr-elem-card',
      '.ckr-prod-card',
      '.ckrp-preview-panel',
      '.ckrp-calc-col',
      '.ckr-section-title',
      '.ckr-coll-header',
    ].join(', ');

    var targets = document.querySelectorAll(selectors);
    if (!targets.length) return;

    // Fade-up osztály hozzáadása
    targets.forEach(function (el) {
      el.classList.add('ckr-fade-up');
    });

    // IntersectionObserver (IE nem támogatja, de Dawn sem IE-re épít)
    if (!('IntersectionObserver' in window)) {
      // Fallback: azonnal láthatóvá tesz mindent
      targets.forEach(function (el) { el.classList.add('ckr-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ckr-visible');
          observer.unobserve(entry.target); // egyszer elég
        }
      });
    }, {
      threshold:  0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ── 4. MOBIL HAMBURGER MENÜ FONT IGAZÍTÁS ──────────────────
     A Dawn natív hamburger menüjébe Marcellus fontot injektál.
  ──────────────────────────────────────────────────────────── */
  function patchMobileMenu() {
    var style = document.createElement('style');
    style.textContent = [
      '.menu-drawer__navigation a,',
      '.menu-drawer a,',
      '.mobile-facets__summary {',
      '  font-family: "Marcellus", serif !important;',
      '  font-size: 1.4rem;',
      '  color: #b0b4d4;',
      '  letter-spacing: .06em;',
      '}',
      '.menu-drawer__navigation a:hover {',
      '  color: #e8c97a !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  /* ── 5. DAWN SECTION BACKGROUND PATCH ───────────────────────
     Ha a Dawn color scheme-ek fehér hátteret adnak,
     felülírja az egyes .shopify-section elemeket.
  ──────────────────────────────────────────────────────────── */
  function patchSectionBackgrounds() {
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (sec) {
      var bg = window.getComputedStyle(sec).backgroundColor;
      // Ha fehér vagy világos (RGB > 200,200,200)
      if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') {
        var match = bg.match(/\d+/g);
        if (match) {
          var r = parseInt(match[0], 10);
          var g = parseInt(match[1], 10);
          var b = parseInt(match[2], 10);
          if (r > 180 && g > 180 && b > 180) {
            sec.style.backgroundColor = '#0b0d1a';
          }
        }
      }
    });
  }

  /* ── 6. TOUCH / SWIPE PREVIEW (mobilon képváltás) ───────────
     A termékoldal collar scene-n touch swipe-ot figyel.
     Bal/jobb húzás → ♀/♂ variáns.
  ──────────────────────────────────────────────────────────── */
  function initTouchSwipe() {
    var scene = document.getElementById('ckrpScene');
    if (!scene) return;

    var startX = 0;
    var THRESHOLD = 40; // px

    scene.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });

    scene.addEventListener('touchend', function (e) {
      var endX = e.changedTouches[0].clientX;
      var diff = endX - startX;

      if (Math.abs(diff) < THRESHOLD) return;

      if (diff < 0) {
        // Balra → férfi variáns
        var malBtn = document.getElementById('ckrpArchMale');
        if (malBtn) malBtn.click();
      } else {
        // Jobbra → közös/női variáns
        var femBtn = document.getElementById('ckrpArchFemale');
        if (femBtn) femBtn.click();
      }
    }, { passive: true });
  }

  /* ── 7. RESPONSIVE GRID IGAZÍTÁS ────────────────────────────
     Ha a képernyő < 480px, az elem kártyákat 1 oszlopra
     állítja (CSS media query backup JS-ben).
  ──────────────────────────────────────────────────────────── */
  

  /* ── 8. CART DRAWER SZINKRONIZÁLÁS ──────────────────────────
     Ha a Dawn cart drawer nyílik, frissíti a kosár badge-t.
  ──────────────────────────────────────────────────────────── */
  function initCartSync() {
    document.addEventListener('cart:updated', function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var badges = document.querySelectorAll(
            '.cart-count-bubble span:first-child, #cart-icon-bubble span:first-child'
          );
          badges.forEach(function (b) {
            b.textContent = cart.item_count;
          });
        })
        .catch(function () {}); // silent fail
    });
  }

  /* ── INIT ────────────────────────────────────────────────────
     DOMContentLoaded után fut, hogy a Dawn elemei már létezzenek
  ──────────────────────────────────────────────────────────── */
  function init() {
    loadFonts();
    initStars();
    initScrollAnimations();
    patchMobileMenu();
    patchSectionBackgrounds();
    initTouchSwipe();
    initCartSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init(); // már betöltött
  }

})();